"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDebugEnabled = function () {
  return localStorage.getItem('ths_widget.debug') || false;
};
exports.log = function (message) {
  return exports.isDebugEnabled() && console.log(message);
};